import React from "react";

const Tabs = () => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g style={{ mixBlendMode: "luminosity" }}>
        <path
          d="M2.58594 14.0391H3.91406V15.2188C3.91406 16.8906 4.79688 17.7656 6.48438 17.7656H14.4062C16.0938 17.7656 16.9766 16.8906 16.9766 15.2188V7.24219C16.9766 5.57031 16.0938 4.69531 14.4062 4.69531H13.0781V3.52344C13.0781 1.85156 12.1953 0.976562 10.5078 0.976562H2.58594C0.890625 0.976562 0.015625 1.85156 0.015625 3.52344V11.4922C0.015625 13.1719 0.890625 14.0391 2.58594 14.0391ZM2.6875 12.4844C1.96875 12.4844 1.57031 12.1094 1.57031 11.3516V3.66406C1.57031 2.90625 1.96875 2.53906 2.6875 2.53906H10.4062C11.1172 2.53906 11.5234 2.90625 11.5234 3.66406V4.69531H6.48438C4.79688 4.69531 3.91406 5.57031 3.91406 7.24219V12.4844H2.6875ZM6.58594 16.2031C5.86719 16.2031 5.47656 15.8281 5.47656 15.0781V7.38281C5.47656 6.63281 5.86719 6.25781 6.58594 6.25781H14.3047C15.0234 6.25781 15.4219 6.63281 15.4219 7.38281V15.0781C15.4219 15.8281 15.0234 16.2031 14.3047 16.2031H6.58594Z"
          fill="#797979"
        />
      </g>
    </svg>
  );
};

export default Tabs;
